import { render } from "./LinkEditor.vue?vue&type=template&id=2e36f3a4"
import script from "./LinkEditor.vue?vue&type=script&lang=js"
export * from "./LinkEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__